export const exampleFormTransaltions = {
  "translationRenderMode": "label-with-seperator/label-only/image-only/image-with-seperator",
  "translationLanguagesSet": [
    {
      "langName": "en",
      "label": "EN",
      "countries": ["United Kingdom", "United States"],
      "flag_image": null,
      "image_style":""
    },
    {
      "langName": "ch",
      "label": "CH",
      "countries": ["China", "Singapore"],
      "flag_image": null,
      "image_style":""
    }
  ],
  "translationFormFields": [
    {
      "class": "hdiscount-translate",
      "type": "header",
      "translations": [
        {
          "langName": "en",
          "label": "Want to get the discount?"
        },
        {
          "langName": "ch",
          "label": "想获得折扣吗？"
        }
      ]
    },
    {
      "class": "paragraph-translate",
      "type": "paragraph",
      "translations": [
        {
          "langName": "en",
          "label": "The NOD is giving the give away of the new product. Please register below to participate in the lucky draw. Good luck!"
        },
        {
          "langName": "ch",
          "label": "NOD赠送了新产品。请在下面注册以参加抽奖。祝好运！"
        }
      ]
    },
    {
      "class": "txtFirstName-translate",
      "type": "text-field",
      "translations": [
        {
          "langName": "en",
          "label": "First Name",
          "placeholder": "First Name"
        },
        {
          "langName": "ch",
          "label": "名字",
          "placeholder": "名字"
        }
      ]
    },
    {
      "class": "age-translate",
      "type": "number",
      "translations": [
        {
          "langName": "en",
          "label": "Age",
          "placeholder": "Enter Your Age"
        },
        {
          "langName": "ch",
          "label": "年龄",
          "placeholder": "输入您的年龄"
        }
      ]
    },
    {
      "class": "dob-translate",
      "type": "date-field",
      "translations": [
        {
          "langName": "en",
          "label": "Date Of Birth",
          "placeholder": "Date Of Birth"
        },
        {
          "langName": "ch",
          "label": "出生日期",
          "placeholder": "出生日期"
        }
      ]
    },
    {
      "class": "btnsubmit-translate",
      "type": "button",
      "translations": [
        {
          "langName": "en",
          "label": "Submit"
        },
        {
          "langName": "ch",
          "label": "提交"
        }
      ]
    },
    {
      "class": "chkFavorite-translate",
      "type": "checkbox-group",
      "translations": [
        {
          "langName": "en",
          "label": "Favorite Fruit",
          "options": [
            "Strawberry",
            "Mango"
          ]
        },
        {
          "langName": "ch",
          "label": "最喜欢的水果",
          "options": [
            "草莓",
            "芒果"
          ]
        }
      ]
    },
    {
      "class": "rdoGender-translate",
      "type": "radio-group",
      "translations": [
        {
          "langName": "en",
          "label": "Gender",
          "options": [
            "Male",
            "Female"
          ]
        },
        {
          "langName": "ch",
          "label": "性别",
          "options": [
            "男",
            "女"
          ]
        }
      ]
    },
    {
      "class": "educationLevel-translate",
      "type": "select",
      "translations": [
        {
          "langName": "en",
          "label": "Education Level",
          "options": [
            "Phd",
            "Master Degree",
            "Bachelor Degree"
          ]
        },
        {
          "langName": "ch",
          "label": "教育程度",
          "options": [
            "Phd",
            "硕士学位",
            "学士文凭"
          ]
        }
      ]
    },
    {
      "class": "addit-translate",
      "type": "text-area",
      "translations": [
        {
          "langName": "en",
          "label": "Additional Information",
          "placeholder": "输入其他信息"
        },
        {
          "langName": "ch",
          "label": "附加信息",
          "placeholder": "输入其他信息"
        }
      ]
    },
    {
      "class": "product-image-translate",
      "type": "image",
      "translations": [
        {
          "langName": "en",
          "label": "Product Image"
        },
        {
          "langName": "ch",
          "label": "产品图片"
        }
      ]
    },
    {
      "class": "isthisyourproduct-translate",
      "type": "yesno-group",
      "translations": [
        {
          "langName": "en",
          "label": "Is This your Product?",
          "yes": "YES",
          "no": "NO"
        },
        {
          "langName": "ch",
          "label": "这是您的产品吗？",
          "yes": "是",
          "no": "没有"
        }
      ]
    },
    {
      "class": "redirectInXSeconds-translate",
      "type": "redirect-in-x-seconds",
      "translations": [
        {
          "langName": "en",
          "label": "Redirect Occurs",
          "prefix_msg": "Redirecting to next page in",
          "suffix_msg": "seconds"
        },
        {
          "langName": "ch",
          "label": "重定向发生",
          "prefix_msg": "重定向到下一页",
          "suffix_msg": "秒"
        }
      ]
    },
    {
      "class": "linktoourproducts-translate",
      "type": "url",
      "translations": [
        {
          "langName": "en",
          "label": "Click to check the latest products"
        },
        {
          "langName": "ch",
          "label": "点击查看最新产品"
        }
      ]
    }
  ]
}

